module.exports = __webpack_public_path__ + "static/img/10.396929b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/zh/10.png
// module id = AcYe
// module chunks = 0